// !!!: ???: keys as french words/phrases ??
// \xa0 (&nbsp;) for cases as 'Utilisateur :', '...oublié ?', '...succès !'
export default Object.freeze({
  general: {
    upload_error: "Erreur de téléversement",
    upload_error_pdf: "Erreur de téléchargement PDF",
    files_must_be_pdfs:
      "Certains fichiers n'ont pas été acceptés. Ils doivent être des fichiers PDF.",
    app_slogan: "plateforme de gestion des votes en assemblées générales",
    Forgot_password: "Mot de passe oublié ?",
    Password: "Mot de passe",
    ProfileInfo: "Informations sur le profil",
    Phone: "Téléphone",
    Logout: "Se déconnecter",
    Username: `Nom d'utilisateur`,
    "N°_de_votant": "N° de votant",
    Numéros_de_lots: "Numéro(s) de lot(s)",
    New_lot: "Nouveau lot",
    droit_de_votes: "Catégories de votes",
    Notification: "Notification",
    Informations: "Informations",
    Subdélégation: "Subdélégation",
    Adresse: "Adresse",
    Civilité: "Civilité",
    Nom: "Nom",
    Prénom: "Prénom",
    Email: "Email",
    No_de_rue: "No de rue",
    Rue: "Rue",
    Complément: "Complément",
    Code_postal: "Code postal",
    Ville: "Ville",
    Pays: "Pays",
    Type_d_envoi_prefere: "Type d'envoi préféré",
    Lre_agreement: "Consentement à la LRE",
    Lre_refusal: "Refus du consentement",
    Lre_agreement_media: "Consentement fichier LRE",
    Copropriété: "Copropriété",
    Indiquer_la_mention_légale: "Indiquer la mention légale",
    Statut: "Statut",
    Majorité: "Majorité",
    Pouvoirs: "Pouvoirs",
    Copropriétaires: "Copropriétaires",
    Mentions: "Mentions",
    Import: "Import",
    Export: "Export",
    Tous: "Tous",
    Yes: "Oui",
    No: "Non",
    SUCCESS: "SUCCÈS",
    ERROR: "ERREUR",
    Browse: "Feuilleter",
    majority_name: "Nom de la majorité",
    loadmore: "Charger plus",
    create: "Ajouter",
    edit: "Éditer",
    duplicate: "Dupliquer",
    delete: "Supprimer",
    reset_sort: "réinitialiser",
    cancel: "Annuler",
    continue: "Continuer",
    enregistrer: "Enregistrer",
    enregistrer_and_continue: "Enregistrer et continuer",
    newtag: "Nouveau tag",
    newresolution: "Nouvelle résolution",
    etiquettes: "Étiquettes",
    tags: "Étiquettes",
    list_de_resolution: "Liste des résolution",
    filter: "Filtre",
    settings: "Paramètres",
    reset: "Réinitialiser",
    accepted_resolution_must: "Pour être accepté, la résolution doit recueillir",
    Send_notifications: "Envoyer des notifications",
    Are_you_sure: "Êtes-vous sûr?",
    Voting_Category_Name: "Nom de la catégorie de vote",
    Name: "Nom",
    Building: "Bâtiment",
    Posibility_revoter_different_majoity: "Possibilité de revoter à une majorité différente",
    Meeting: "Convocation",
    Meetings: "Convocations",
    Choose_a_file_or_drop_it_here: "Choisissez un fichier ou déposez-le ici ...",
    Drop_file_here: "Déposer le fichier ici ...",
    New_Copropriétaire: "Nouveau copropriétaire",
    New_Volume: "Ajouter un volume",
    Mention_à_faire_apparaître_sur_le_procèsverbal:
      "Mention à faire apparaître sur le procès-verbal",
    no_charges_generales: "Pas de charges generales",
    set_charges_generales_now: "Voulez-vous les définir maintenant?",
    accepte_resolution_must: "Pour être accepté, la résolution doit recueillir\xa0:",
    delete_question: "Êtes-vous sûr?",
    message_yes: "Oui",
    message_no: "Non",
    select_no_option: "Veuillez saisir une option existante",
    select_with_input_no_option: "Veuillez saisir une option existante ou une nouvelle",
    general_charges: "Charge générale",
  },

  //@ Table
  // Catalogs
  // Catalogs Resolutions
  dt_catalog_name_key: "Nom",
  dt_catalog_nr_resolution_key: "Nombre de résolutions",
  dt_catalog_tags_key: "Étiquettes",
  dt_catalog_filter_tags_key: "Étiquettes",
  dt_catalog_filter_name_key: "Nom",
  dt_resolution_name_key: "Nom",
  dt_resolution_description_key: "La description",
  dt_resolution_filter_name_key: "Nom",
  dt_resolution_filter_description_key: "La description",
  // Catalogs des Immeubles
  dt_building_name_key: "Nom",
  dt_building_address_key: "Adresse",
  dt_building_coownership_key: "Copropriété",
  dt_building_with_majority_key: "Avec la majorité",
  dt_building_filter_name_key: "Nom",
  dt_building_filter_address_key: "Adresse",
  dt_building_filter_coownership_key: "Copropriété",
  dt_building_filter_with_majority_key: "Avec la majorité",
  // Catalogues des Majorites
  dt_majority_name_key: "Nom",
  dt_majority_contitions_key: "Info",
  dt_majority_filter_name_key: "Nom",

  //Convocations

  convocation_choose_notification_type: "Choisissez le type de notification de convocation",
  convocation_send_manually: "Manuellement",
  convocation_send_cogeprint: "CogePrint",
  //Meetings
  dt_meetings_building_key: "Immeuble",
  dt_meetings_name_key: "Nom convocation", // Meeting name
  dt_meetings_date_key: "Date",
  dt_meetings_access_key: `Modalités d'accès`,
  dt_meetings_nr_resolutions_key: "Nombre de résolutions",
  dt_meetings_filter_building_key: "Immeuble",
  dt_meetings_filter_name_key: "Nom convocation",
  dt_meetings_filter_date_key: "Date",
  dt_meetings_filter_access_key: "Modalités d'accès",
  //
  dt_voting_name_key: "Convoqué",
  dt_voting_representant_key: "Representative",
  dt_voting_for_key: "Pour",
  dt_voting_abstain_key: "Abs.",
  dt_voting_against_key: "Contre",
  dt_voting_filter_name_key: "Convoqué",
  dt_voting_filter_representant_key: "Representative",
  dt_voting_filter_vote_key: "Vote",

  //
  dt_meeting_resolutions_name_key: "Nom",
  dt_meeting_resolutions_description_key: "Description",
  dt_meeting_resolutions_voting_rights_key: "Catégorie de vote",
  dt_meeting_resolutions_majority_key: "Majorité",
  dt_meeting_resolutions_filter_name_key: "Nom",
  dt_meeting_resolutions_filter_description_key: "Description",
  dt_meeting_resolutions_filter_voting_right_key: "Catégorie de vote",
  dt_meeting_resolutions_filter_majority_key: "Majorité",
  dt_mandate_filter_name_key: "Nom",

  //
  dt_mandate_cogeprint_status: "Cogeprint status",
  dt_mandate_email_status: "Email status",
  dt_mandate_number_key: "No vote",
  dt_mandate_name_key: "Nom",
  dt_mandate_representant_key: "Representative",
  dt_mandate_logs_key: "Logs",
  dt_mandate_pouvoir_media: `Pouvoir`,
  dt_mandate_voting_form_id: `Formular du vote`,
  dt_mandate_invitation_id: `Convocation`,
  dt_mandate_agenda_pdf: `Order du jour`,
  //Voting Categories
  dt_voting_cat_name_key: "Nom",
  dt_voting_cat_building_key: "Immeuble",
  dt_voting_cat_filter_name_key: "Nom",
  dt_voting_cat_filter_building_key: "Immeuble",
  dt_is_charge_generale_key: "Est une charge générale",
  dt_is_charge_generale_filter_key: "Est une charge générale",
  //
  // Coproprietaire
  dt_building_owner_nr_votant_key: "No votant",
  dt_building_owner_name_key: "Nom",
  dt_building_owner_email_key: "Email",
  dt_building_owner_filter_nr_votant_key: "No votant",
  dt_building_owner_filter_name_key: "Nom",
  dt_building_owner_filter_email_key: "Email",
  dt_building_owner_tantiemes_key: "Tantièmes",
  dt_building_owner_lre_agreement_key: "Consentement à la LRE",
  dt_building_owner_delete_all: "Supprimer tous les copropriétaires",

  //

  header: {
    my_account: "Mon compte",
    home: "Accueil",
    tableau_au_bord: "Tableau de bord",
    catalogs: "Catalogues",
    meetings: "Convocations",
    configurations: "Configurations",
    enregistrer: "Enregistrer",
  },

  catalogs: {
    home: "Accueil",
    catalogs: "Catalogues",
    resolutions: "Résolutions",
    catalog_name: "Nom du catalogue",
    resolutions_catalogs: "Catalogues des Résolutions",
    resolutions_create: "Ajouter un Catalogue des Résolutions",
    resolutions_edit: "Éditer un Catalogue des Résolutions",
    buildings: "Immeubles",
    buildings_catalogs: "Catalogues des Immeubles",
    buildings_create: "Ajouter une copropriété",
    buildings_asl_create: "Ajouter une ASL",
    buildings_edit: "Éditer un Catalogue des Immeubles",
    buildings_asl_edit: "Éditer un ASL",
    majorities: "Majorités",
    majorities_catalogs: "Catalogues des Majorités",
    majorities_create: "Ajouter un Catalogue des Majorités",
    majorities_edit: "Éditer un Catalogue des Majorités",
    // ???: keys as french words/phrases ??
    Le_nom_du_copropriété: "Le nom de l'immeuble",
    Ladresse_du_copropriété: `L'adresse de l'immeuble`,
    Ladresse_du_asl: `L'adresse d'ASL`,
    Le_nom_du_asl: "Le nom d'ASL",
    Statut_de_copropriété: "Activer le statut de la copropriété sur cet immeuble",
    Limmeuble_est_soumis_à_un_plafond_de_majorité: "L’immeuble est soumis à un plafond de majorité",
    Copropriété: "Copropriété",
    article22: "Activer l'article 22",
    Définir_le_plafond_de_majorité: "Plafond de majorité",
    Les_pouvoirs_sont_conditionnés: "Les pouvoirs sont conditionnés",
    Pouvoirs_par_mandataire: "Pouvoirs par mandataire",
    Possibilité_de_combiner_les_deux: "Possibilité de combiner les deux",
    Tantièmes_détenus: "Tantièmes détenus",
    Mandataire_inclus: "Mandataire inclus",
    Par_exemple_3_pouvoirs_par_mandataire_OU_10_de_tantièmes_détenus:
      "Par exemple 3 pouvoirs par mandataire OU 10% de tantièmes détenus.",
    Nom_de_la_majorité: "Nom de la majorité",
    un_total_de_tantièmes: "un total de tantièmes",
    un_nombre_de_votants: "un nombre de votants",
    "défavorables_/_pour": "défavorables / contre",
    qui_doit_être: "qui doit être",
    des_tantièmes_ou_des_votants: "des tantièmes ou des votants",
    selon_le_1er_choix: "selon le 1er choix",
    avec_cumul_des_mandats: "avec cumul des mandats",
    sans_cumul_des_mandats: "sans cumul des mandats",
    Ainsi_1_votant_avec_2_mandats_compte_pour_3_votants:
      "Ainsi, 1 votant avec 2 mandats compte pour 3 votants (cas de copropriété)",
    Ainsi_1_votant_avec_2_mandats_compte_pour_1_votant:
      "Ainsi, 1 votant avec 2 mandats compte pour 1 votant",
    Possibilité_de_revote_à_une_majorité_différente:
      "Possibilité de revote à une majorité différente",
    modal: {
      voting_category_name: "Catégorie de vote",
      firstname: "Prénom",
      lastname: "Nom",
      gender: "Civilité",
      email: "Email",
      address: "Adresse",
      complement: "Adresse complément 1",
      complement_2: "Adresse complément 2",
      zipcode: "Code postal",
      city: "Ville",
      country: "Pays",
      contact_type: "Type d’envoi préféré",
      entity_type: "Type d'entité",
    },
  },
  footer: {
    message: "Logiciel des votes en assemblées générales",
  },

  meetings: {
    // for table
    building: "Immeuble",
    name: "Nom convocation",
    date: "Date",
    access: "Modalités d'accès",
    resolutions: "Nombre de résolutions",
    //
    create_meeting: "Créer une réunion",
    edit_meeting: "Modifier la réunion",
    another_in_progress: "Il y a une autre réunion en cours",
    meeting: {},

    votingTable: {
      name: "Propriétaire",
      representant: "Représenté par",
      for: "Pour",
      abs: "Abs.",
      against: "Contre",
      vote: "Vote",
    },

    meeting_correspondence: {
      add_new: "Ajouter un vote par correspondance",
    },

    meeting_agenda: {},

    meeting_presence: {},

    meeting_start: {},
    meeting_create: "Ajouter une réunion",
    presence_count: "Taux de Présence (Nombre de copropriétaires)\xa0:",
    present: "Présents",
    representatives: "Représentants",
    total_present: "Total présents ou représentants",
    absent: "Absents non représentés",
    total: "Total",
    email: "Email",
  },

  category: {
    create_categoty: "Ajouter une nouvelle catégorie",
  },

  resolutions: {
    no: "Résolution n°",
    sub_no: "Sous résolution n°",
    libelle_resolution: "Nom résolution",
    libelle_sous_resolution: "Nom sous résolution",
    majority: "Majorité",
    details_resolution: "Détails de la résolution",
    details_sous_resolution: "Détails de la sous résolution",
    files: "Fichiers",
    without_vote: "Sans Vote",
  },

  buildings: {
    building_created: "Immeuble créé",
    building_created_successfully: "Immeuble créé avec succès",
  },

  voting_categories: {
    title: "Catégories de vote",
  },

  configuration_settings: {
    title: "Les paramètres",
    titleLegalMentions: "Mentions légales",
    titlePdfSettings: "Configurer PDF",
    titleAgencyLRESettings: "Agence",
    createLegalMentions: "Ajouter une nouvelle mention légales",
    createPdfSettings: "Ajouter une nouvelle pdf configuration",
    create_settings: "Ajouter une nouvelle parameter",
  },

  duplicate_meeting: {
    warning_message:
      "Au cours du processus de duplication, nous avons constaté que certains fichiers des pièces jointes de résolution manquaient sur le serveur. Nous avons dupliquer la réunion mais sans les pièces jointes de la résolution concernée.",
  },

  // Special characters
  "catalogs.modal.*building_lot*": "Lot",
  // HACK: copied from api translations
  "pdf.convocation.header.line.one": "Convocation à l'Assemblée Générale du ",
  "pdf.convocation.header.line.two": "- SDC 22 rue des Envierges",
  "pdf.convocation.main.title.one": "Convocation pour l'Assemblée Générale",
  // "pdf.convocation.header.line.two.part.a": "Générale ",
  "pdf.convocation.header.line.two.part.b": "Ordinaire",
  "pdf.convocation.company.identification.title": "Rappel des coordonnées de l'organisateur :",
  "pdf.convocation.company.identification.line.one":
    "LESUR IMMOBILIER, 13 bis avenue de la Motte Piquet, 75007 -",
  "pdf.convocation.company.identification.line.two": "PARIS", // ???: ..
  "pdf.convocation.company.identification.line.three": "syndic@lesurimmobilier.fr | +33184254237",
  "pdf.convocation.asociation.identification.title": "Copropriété :",
  "pdf.convocation.asociation.identification.line.one": "SDC 22 rue des Envierges",
  "pdf.convocation.asociation.identification.line.two": "22 rue des Envierges",
  "pdf.convocation.asociation.identification.line.three": "75020 - PARIS",
  "pdf.convocation.date.line.one": "le 10 avril 2019",
  "pdf.convocation.date.line.two": "Madame, Monsieur,",
  "pdf.convocation.date.line.three":
    "Conformément à la loi du 10 Juillet 1965 (modifiée par la loi du 31/12/1985 et le décret du 09/06/1986) et au règlement de copropriété, nous vous invitons à participer à l'Assemblée Générale de votre copropriété qui se tiendra,",
  "pdf.convocation.address.line.one": "le 17 mai 2019 à 15h00",
  "pdf.convocation.address.line.two": "à l'adresse suivante :",
  "pdf.convocation.address.line.three": "Studio Krom - 18 Rue du Moulin Joly 75011 Paris",
  "pdf.convocation.details.title": "Vous trouverez ci-joint :",
  "pdf.convocation.details.line.one": "L'ordre du jour de cette Assemblée",
  "pdf.convocation.details.line.two": "Les projets de résolutions",
  "pdf.convocation.details.line.three": "Le pouvoir pour être représenté",
  "pdf.convocation.details.line.four":
    "Le relevé général des dépenses de l'exercice écoulé du 01/01/2018 au 31/12/2018 ainsi que ses annexes comptables",
  "pdf.convocation.details.line.five": "Le projet individuel de répartition",
  "pdf.convocation.details.line.six": "Les annexes comptables",
  "pdf.convocation.details.line.seven":
    "Les documents suivants qui aideront à la compréhension des résolutions:",
  "pdf.convocation.details.resolutions.line.one":
    "Résolution n°8 - Contrat syndic Lesur Immobilier 2019.pdf",
  "pdf.convocation.details.resolutions.line.two":
    "Résolution n°12 - Analyse des offres architectes Cours transvaal.pdf",
  "pdf.convocation.details.resolutions.line.three":
    "Résolution n°12 - Analyse des offres architectes RSO.pdf",
  "pdf.convocation.details.resolutions.line.four": "Résolution n°12 - Proposition Prud'homme.pdf",
  "pdf.convocation.details.resolutions.line.five": "Résolution n°12 - Proposition Battistel.pdf",
  "pdf.convocation.details.resolutions.line.six": "Résolution n°12 - Proposition De Franchis.pdf",
  "pdf.convocation.details.resolutions.line.seven":
    "Résolution n°19 - Devis Création local vélo.pdf",
  "pdf.convocation.details.summary.line.one":
    "Au cas où vous ne pourriez pas assister à la présente Assemblée Générale, nous vous serions reconnaissants de bien vouloir utiliser le pouvoir joint, au nom d'un mandataire de votre choix. Le syndic ne peut accepter de procuration.",
  "pdf.convocation.details.summary.line.two":
    "Nous vous prions d'agréer, Madame, Monsieur, l'expression de nos sincères salutations.",
  "pdf.convocation.footer.line.one":
    "LESUR Immobilier - S.A.R.L au capital de 5 000 € 794 798 645 RCS Paris",
  "pdf.convocation.footer.line.two": "13 bis, avenue de la Motte Piquet 75007 Paris",
  "pdf.convocation.footer.line.three":
    "Garantie financière : GALIAN, 89 Rue de la Boétie 75008 Paris - Carte CPI 7501 2017 000 017 515",

  // ORDER DU JOUR
  "pdf.order.du.jour.voting": "- Clé de vote",
  "pdf.order.du.jour.majority": "- Majorité",
  "pdf.order.du.jour.header.line.one": "Convocation à l'Assemblée Générale du",
  "pdf.order.du.jour.header.line.two": "- SDC 22 rue des Envierges",
  "pdf.order.du.jour.main.title.one": "Ordre du jour",
  "pdf.order.du.jour.main.title.two": "SDC 22 rue des Envierges",
  "pdf.order.du.jour.date.line.one": "22 rue des Envierges, 75020 - PARIS",
  "pdf.order.du.jour.date.line.two":
    "Assemblée du 17 mai 2019 à 15h00, à l'adresse : Studio Krom - 18 Rue du Moulin Joly 75011 Paris",
  "pdf.order.du.jour.date.line.three":
    "Cette Assemblée sera appelée a délibérer exclusivement sur l'ordre du jour suivant :",
  "pdf.order.du.jour.voting.simple.majority":
    "Majorité simple : Article 24 - Clé de vote : Charges générales",
  "pdf.order.du.jour.voting.no.vote": "Sans vote",
  "pdf.order.du.jour.voting.absolute.majority":
    "Majorité absolue : Article 25 , revotable dans les conditions de l'article 25-1 - Clé de vote : Charges générales",
  "pdf.order.du.jour.item.one": "Election du Président de séance",
  "pdf.order.du.jour.item.two": "Election d'un scrutateur",
  "pdf.order.du.jour.item.three": "Election du Secrétaire de séance",
  "pdf.order.du.jour.item.four": "Compte rendu annuel du Conseil Syndical",
  "pdf.order.du.jour.item.five": "Bilan du syndic",
  "pdf.order.du.jour.item.six":
    "Approbation des comptes de l'exercice du 1 janvier 2018 au 31 décembre 2018",
  "pdf.order.du.jour.item.seven":
    "Vote du budget prévisionnel de l'exercice du 1 janvier 2020 au 31 décembre 2020",
  "pdf.order.du.jour.item.eight": "Remplacement des compteurs divisionnaires eau froide",
  "pdf.order.du.jour.item.nine": "Remplacement des compteurs divisionnaires eau froide",
  "pdf.order.du.jour.item.ten":
    "Action en justice à l'encontre du propriétaire du lot 9 - quatrième étage droite",
  "pdf.order.du.jour.item.eleven": "Action en justice à l'encontre du cabinet SIA et COGEIM",
  "pdf.order.du.jour.item.twelve": "Synthèse des travaux de reprise en sous oeuvre",
  "pdf.order.du.jour.item.thirteen":
    "Choix de l'architecte pour les travaux de consolidation de la courette côté Transvaal",
  "pdf.order.du.jour.item.fourteen": "Choix de l'architecte pour les travaux de RSO",
  "pdf.order.du.jour.item.fifteen": "Mandat pour études complémentaires",
  "pdf.order.du.jour.item.sixteen": "Modalité de constitution du fonds de travaux 2020",
  "pdf.order.du.jour.item.seventeen": "Avance pour travaux",
  "pdf.order.du.jour.item.eighteen":
    "Etude de conformité entre l'usage des lots et l'état descriptif",
  "pdf.order.du.jour.item.nineteen": "Création local vélo",
  "pdf.order.du.jour.item.twenty": "lection du Conseil Syndical",
  "pdf.order.du.jour.item.twentyone": "Questions diverses",
  "pdf.order.du.jour.footer.line.one":
    "LESUR Immobilier - S.A.R.L au capital de 5 000 € 794 798 645 RCS Paris",
  "pdf.order.du.jour.footer.line.two": "13 bis, avenue de la Motte Piquet 75007 Paris",
  "pdf.order.du.jour.footer.line.three":
    "Garantie financière : GALIAN, 89 Rue de la Boétie 75008 Paris - Carte CPI 7501 2017 000 017 515",

  // # proces verbal pdf
  "pdf.proces.verbal.header.company.line.one": "Procès verbal de l'assemblée générale",
  "pdf.proces.verbal.header.company.line.two": " - SDC 22 rue des Envierges ",
  "pdf.proces.verbal.title.line.one": "Procès verbal de l’assemblée générale",
  "pdf.proces.verbal.title.line.two": "du 17 mai 2019",
  "pdf.proces.verbal.title.line.three": "SDC 22 rue des Envierges 75020 Paris",
  "pdf.proces.verbal.introduction.line.one": "Chers membres du syndicat des copropriétaires, ",
  "pdf.proces.verbal.introduction.line.two":
    "Le 17 mai 2019, les copropriétaires se sont réunis en assemblée générale, laquelle s’est tenue le 17 mai 2019, à partir de 15h00, à l’adresse",
  "pdf.proces.verbal.introduction.line.three": `Il a été dressé une feuille de présence qui a été signée par tous les copropriétaires
    présents et par les mandataires de ceux qui étaient représentés.`,
  "pdf.proces.verbal.introduction.line.four":
    "Après vérification de la feuille de présence, il est constaté que :",
  "pdf.proces.verbal.present.represented": "Sont présents ou représentés",
  "pdf.proces.verbal.absent.not.represented": "Sont absents et non représentés",
  "pdf.proces.verbal.pv.voting.distribution":
    "En vertu de l’article 22, alinéa 2, de la loi du 10 juillet 1965, le nombre de voix dont dispose le copropriétaire majoritaire « Monsieur HAYEM » sera réduit à la somme des voix des autres copropriétaires. Ainsi, « Monsieur HAYEM » dispose de 220 voix au lieu de 456.",
  "pdf.proces.verbal.subjects.title": "Afin de délibérer sur l’ordre du jour suivant ",
  "pdf.proces.verbal.voting.simple.majority": "Majorité Article 24 - Charges générales",
  "pdf.proces.verbal.voting.simple.majority.passed":
    "Cette résolution est adoptée à la majorité de l’article 24",
  "pdf.proces.verbal.voting.absolute.majority": "Majorité Article 25 - Charges chauffage",
  "pdf.proces.verbal.voting.absolute.majority.passed":
    "En vertu de l’article 25-1, cette résolution fait l’objet d’un second vote à la majorité de l’article 24",
  "pdf.proces.verbal.voting.update.line.one":
    "Arrive en cours de séance à 15h36, Madame BENARD DE SAINT SEINE (90), avant le vote de la résolution n°5.",
  "pdf.proces.verbal.voting.update.line.two":
    "La feuille de présence fait désormais référence à 3 copropriétaires présents ou représentés, totalisant 440 tantièmes sur 440.",
  "pdf.proces.verbal.ending.details": "Fait à :",
  "pdf.proces.verbal.details.management.line.one": "Le Président de séance",
  "pdf.proces.verbal.details.management.line.two": "Le Secrétaire de séance",
  "pdf.proces.verbal.details.management.line.three": "Le(s) Scrutateur(s)",

  // # pouvoir pdf
  "pdf.pouvoir.header.line.one": "Votre pouvoir pour la prochaine assemblée générale, ",
  "pdf.pouvoir.header.line.two": "le jeudi 11 avril 2019",
  "pdf.pouvoir.main.title.one": "Pouvoir",
  "pdf.pouvoir.main.title.two": "pour l'Assemblée Générale",
  "pdf.pouvoir.owner.identification.one": "Je soussigné ",
  "pdf.pouvoir.owner.identification.two": ", titulaire de ",
  "pdf.pouvoir.owner.identification.three":
    ", agissant en qualité de copropriétaire de la copropriété",
  "pdf.pouvoir.owner.identification.four": "située au :",
  "pdf.pouvoir.owner.identification.five": "donne, par le présent, tous pouvoirs à:",
  "pdf.pouvoir.owner.identification.six": "ou à défaut à :",
  "pdf.pouvoir.effects.title": "À effet :",
  "pdf.pouvoir.effects.line.one":
    "D'assister à l'Assemblée Générale des Copropriétaires de l'immeuble ci-dessus indiqué, convoquée le",
  "pdf.pouvoir.effects.line.two":
    "De me représenter et exercer tous les droits que je tiens du règlement de Copropriété et de la loi ;",
  "pdf.pouvoir.effects.line.three":
    "De prendre part, en mon nom, à toutes délibérations, discussions et à tous votes, faire toutes protestations oppositions, réserves ;",
  "pdf.pouvoir.effects.line.four":
    "D'accepter toutes fonctions et tous mandats, signer toute feuille de présence, ainsi que tous procès-verbaux de séance et tous actes relatifs à l'administration des parties communes ;",
  "pdf.pouvoir.effects.line.five":
    "De se substituer et généralement faire le nécessaire pour assurer ma représentation à la dite Assemblée Générale.",
  "pdf.pouvoir.effects.details":
    "Dans la mesure où je ne préciserais pas nommément de mandataire mon pouvoir sera remis au Président de séance pour présider ladite Assemblée Générale avec la faculté pour lui de se substituer à toute personne de son choix. Ce mandat prendra donc effet après désignation du Président de séance. Sera retenu comme pouvoir la dernière personne ayant reçu mon pouvoir.",
  "pdf.pouvoir.signature.mandant": "Signature du mandant",
  "pdf.pouvoir.signature.mandataire": "Signature du mandataire",
  "pdf.pouvoir.signature.details": "Dater, signer et mettre de sa main la mention",
  "pdf.pouvoir.signature.ok.pouvoir": "'BON POUR POUVOIR'",
  "pdf.pouvoir.signature.ok.acceptation": "'BON POUR ACCEPTATION'",
  "pdf.pouvoir.mentions":
    "1. Rappel : Le syndic ne peut pas représenter un copropriétaire, une même personne pourra recevoir plus de trois mandats de vote si le total des voix dont elle dispose n'excède pas 15% de la totalité des voix du Syndicat.",
  "pdf.pouvoir.footer.line.one":
    "LESUR Immobilier - S.A.R.L au capital de 5 000 € 794 798 645 RCS Paris",
  "pdf.pouvoir.footer.line.two": "13 bis, avenue de la Motte Piquet 75007 Paris",
  "pdf.pouvoir.footer.line.three":
    "Garantie financière : GALIAN, 89 Rue de la Boétie 75008 Paris - Carte CPI 7501 2017 000 017 515",

  // # feuille de presence pdf
  "pdf.presence.header.company.line.one": "Motte Piquet Lore Ipsum",
  "pdf.presence.header.company.line.two": " 22 rue des l'Union ",
  "pdf.presence.header.company.line.three": "93000 BOBIGNY",
  "pdf.presence.header.title.line.one": "Feuille de présence Asemblée Générale du 19/09/2019",
  "pdf.presence.header.title.line.two":
    "Editée suivant la clé CHNAGES GENERALES, tantiémes globaux 10 122",
  "pdf.presence.header.pagination.line.one": "Page - ",
  "pdf.presence.table.title.owner": "Copropriétaire",
  "pdf.presence.table.title.flat": "Lot",
  "pdf.presence.table.title.fees": "Tantiémes",
  "pdf.presence.table.title.total": "Total",
  "pdf.presence.table.title.present": "Tantiémes Présents",
  "pdf.presence.table.title.absent": "Tantiémes Absents",
  "pdf.presence.table.title.mandataire": "Mandataire",
  "pdf.presence.table.title.signature": "Emargegemnt",
  "pdf.presence.table.title.contact": "Contact",
  "pdf.presence.table.title.signed": "Signature",
  "pdf.presence.details.management.line.one": "Président",
  "pdf.presence.details.management.line.two": "Secrétaire",
  "pdf.presence.details.management.line.three": "Scrutateurs",
});
